import { createSlice } from "@reduxjs/toolkit";
// import duplicateStudy from "@custom/rtk-apis/DCM4CHEE/duplicateStudy";
import createIsoImage from "@custom/rtk-apis/media-service/mediaService";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const createIsoImageSlice = createSlice({
  name: "createIsoImageSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(createIsoImage.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(createIsoImage.fulfilled, (state, { payload }) => {
        console.log("Fulfilled for media slice",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.msg = 'ISO created Successfully.';
        state.error=''
      })
      .addCase(createIsoImage.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
        state.msg = 'ISO creation Failed.'
      });
  },
});

export default createIsoImageSlice.reducer;
